import { deliveryStatusOptions } from '@/_pages/settings/email-history/shared/model';

/** Latest email delivery status values for invoice list advanced filters. */
export const invoiceEmailDeliveryStatusOptions = deliveryStatusOptions;
